/**
 * Unicode BMP 区块 → 密文字体键名。
 * 数据从 cipher_font_blocks.json 加载（同一文件供 Python Excel 端共享）。
 * 顺序无关；查找时对 code point 做区间匹配。
 */
import type { CipherFontKey } from './types';
import blockData from './cipher_font_blocks.json';

export const CIPHER_FONT_BLOCK_RANGES: ReadonlyArray<readonly [number, number, CipherFontKey]> =
  blockData as ReadonlyArray<readonly [number, number, CipherFontKey]>;

/** 按 code point 查找字体键（表内区间互不重叠） */
export function lookupCipherFontKey(cp: number): CipherFontKey | null {
  for (const [start, end, key] of CIPHER_FONT_BLOCK_RANGES) {
    if (start <= cp && cp <= end) return key;
  }
  return null;
}
